import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../../utils/TableCustomStyles";


function PlannedExportTasks(props) {
  const [taskSequenceData, setTaskSequenceData] = useState([]);
  const [taskSequenceDataPending, setTaskSequenceDataPending] = useState(true);

  const shipment_id = props.shipmentId
  const currentUserRolePermissionData = props.currentUserRolePermissionData

  const user_role_name = sessionStorage['currentRoleName']  

  const getTaskSequence = async (shipment_id) => {
    setTaskSequenceDataPending(true)
    try {
      const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL + '/master/tasksequencetable/gettasklist?shipment='+shipment_id+'&assigned_to='+user_role_name);
      if (response) {
        const sorted_data = response.data.sort((a, b) => a.task_data?.sequence - b.task_data?.sequence)
        setTaskSequenceData(sorted_data)
      }
    } catch (err) {
      toast.error("Error in fetching task data! Try again.");
    }
    setTaskSequenceDataPending(false)
  }

  useEffect(() => {
    getTaskSequence(shipment_id)
  }, [shipment_id]);


  const tasksequencecolumns = [
    {
      name: 'Sequence',
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: 'Task',
      selector: row => row.task_data?.name,
      sortable: true,
    },
    {
      name: 'Sub Task',
      selector: row => row.task_data?.sub_task_name,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
    },
    {
      name: 'Action',
      width: '110px',
      center: true,
      selector: row =>
        <div>
          {
            currentUserRolePermissionData?.includes("shipment:task:update") ?
              <Button className="btn btn-sm btn-inox-green border-0 my-1" style={{ height: 30 }} title="Update">
                <i className="fa fa-check"></i>
              </Button>
              :
              ""
          }
        </div>,
    }
  ];

  return (
    <div>
      <div className="col-12 text-left" style={{ marginTop: -5 }}>
        <DataTable
          columns={tasksequencecolumns}
          data={taskSequenceData}
          progressPending={taskSequenceDataPending}
          progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true" />}
          noDataComponent={<p className="text-center table-no-data">No Task Found</p>}
          highlightOnHover
          customStyles={tableCustomStyles}
          dense
        />
      </div>
    </div>
  );
}

export default PlannedExportTasks;
